import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { environment } from "environments/environment";

@Pipe({
  name: "avatarUrl",
})
export class AvatarUrlPipe implements PipeTransform {
  private datePipe = new DatePipe("en-US");

  transform(avatar: string): string {
    const avatarLastModified = new Date(),
      apiUrl = environment.apiUrl;
    if (!avatar) {
      return "";
    }

    //check if avatar is a full url
    if (avatar.startsWith("http://") || avatar.startsWith("https://")) {
      return avatar;
    }

    const formattedDate = this.datePipe.transform(avatarLastModified, "yyyyMMddHHmmss") || "";
    return `${apiUrl}/${avatar}?v=${formattedDate}`;
  }
}
